export default {
  scoopOffset: 152,
  scoopBase: 135,
  introSprites: [{ sn: 'IntroTreat+1', x: 80, y: 602 },
    { sn: 'IntroTreat+2', x: 285, y: 768 },
    { sn: 'IntroTreat+3', x: 522, y: 677 },
    { sn: 'IntroTreat+4', x: 773, y: 701 },
    { sn: 'IntroTreat+5', x: 903, y: 644 }],
  menuData: [
    { category: 'Container', type: 1, id: 1, count: 4, tabColor: '#ef7d54', helpSound: 'Cone_Container' },
    { category: 'Flavor', type: 2, id: 2, count: 5, tabColor: '#bedd05', arrowColor: '#a83800', helpSound: 'What_Flavor' },
    { category: 'Sauce', type: 2, id: 3, count: 4, tabColor: '#c395db', colors: ['#c97f27','#723f01','#cd05d8','#74eda5'], helpSound: 'Sauce' },
    { category: 'Whipped Cream', id: 4, type: 2, count: 4, tabColor: '#85d3cf', helpSound: 'Whipped_Cream' },
    { category: 'Toppings', id: 5,type: 2, count: 5, tabColor: '#e077bd', helpSound: 'Toppings' }
  ],
  containerIsDish: [false,false,true,true]
};